import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/clientmanagment/newclient",
    data: data,
  });
};

export const GetData = async (pageNumber, limit = 15) => {
  return await Get({
    url: "/clientmanagment/show_list",
    data: {
      limit: limit,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/clientmanagment/destroy",
    data: data,
  });
};

export const DataSearch = async (data, limit = 15, page = null) => {
  return await Get({
    url: "/clientmanagment/show_list",
    data: {
      limit: limit,
      ...data,
    },
    page: page,
  }).then(data => {
    return data;
  });
};
export const EditData = async data => {
  await Set({
    url: "/clientmanagment/update",
    data: data,
  });
};

export const BanUser = async data => {
  await Set({
    url: "/clientmanagment/toggle_user",
    data: data,
  }).then(data => {
    return data;
  });
};
export const getTemporary = async data => {
  return await Get({
    url: "/temporarypass/create",
    data: data,
  }).then(data => {
    return data;
  });
};
